import { getAuthEnvUrlForPassport } from './config/env';

export const HOME = '/';

/// /////// Profile Paths
export const profileBasePath = '';

export const pageRoutes = {
  PROFILE_PAGE: `${profileBasePath}/profile/`,
  PROFILE_EDIT: `${profileBasePath}/profile/edit`,
  MANAGE_USERS_PAGE: '/account/permissions',
  NAME_EDIT_ROUTE: '/name',
  DESIGNATION_EDIT_ROUTE: '/designation',
  MANAGE_PERMISSIONS_PATH: '/account/manage-permissions/',
  VIEW_PROFILE: `${profileBasePath}/profile/view/:customerId`,
};

/// /////// Invitation Paths
export const invitationBasePath = '/invitation';
export const acceptInvitation = `${invitationBasePath}/accept`;

export const hashPaths = {
  USERS: '#/overview/users',
  OPEN_INVITATIONS: '#/overview/users/invitations',
  DEACTIVATED_USERS: '#/overview/users/deactivated',
};

export const PUMS_AUTHENTICATION_PATH = 'user/auth';
export const PUMS_FEDERATE_REDIRECT_CURRENT_PATH = `?origin=${window.location.href}`;

export const PUMS_FEDERATE_REDIRECT_MANAGE_USERS_PAGE_PATH = `?origin=${
  window.location.origin + pageRoutes.MANAGE_USERS_PAGE
}`;

export const PUMS_NAV_LINK =
  getAuthEnvUrlForPassport() +
  PUMS_AUTHENTICATION_PATH +
  PUMS_FEDERATE_REDIRECT_CURRENT_PATH;

export const PUMS_NAV_MANAGE_USERS_PAGE_LINK =
  getAuthEnvUrlForPassport() +
  PUMS_AUTHENTICATION_PATH +
  PUMS_FEDERATE_REDIRECT_MANAGE_USERS_PAGE_PATH;

export const INTERNAL_LP_DETAILS_PATH = '/logisticsProviders/:lpId';
